import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_StudentLocker } from "../shared/data.service";
import { LockerPersonUnassignRequest } from "../shared/LockerPersonUnassignRequest";
import * as moment from "moment";

@Component({
	selector: "app-student-remove-locker",
	templateUrl: "./student-remove-locker.component.html",
	styleUrls: ["./student-remove-locker.component.css"],
})
export class StudentRemoveLockerComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private StudentLockerService: DataService_StudentLocker
	) {}

	ngOnInit(): void {
		this.SelectedLockerPerson = this.dialogConfig.data.SelectedLockerPerson;
		this.SelectedPerson = this.dialogConfig.data.SelectedPerson;
		this.user = this.dialogConfig.data.user;

		this.StudentName = this.SelectedPerson.PersonName;

		this.LockerComment = this.SelectedLockerPerson.LockerComment;
		this.AssignmentComment = this.SelectedLockerPerson.AssignmentComments;
	}

	////////////////////////////////////////
	// Data
	////////////////////////////////////////
	SelectedLockerPerson: any;
	SelectedPerson: any;
	user: any;

	StudentName: any;

	//Form
	LockerStatusID: any = 1;
	lstLockerStatus: any = [
		{
			ID: 1,
			Desc: "All",
		},
		{
			ID: 2,
			Desc: "Assigned",
		},
		{
			ID: 3,
			Desc: "Unassigned",
		},
	];

	SelectedLocker: any;
	lstLockerAll: any = [];
	lstLocker: any = [];

	AssignedDate: Date = new Date();

	LockerComment: any = "";
	AssignmentComment: any = "";

	////////////////////////////////////////

	////////////////////////////////////////
	// Buttons
	////////////////////////////////////////
	onUnassign() {
		let parms: LockerPersonUnassignRequest = {
			LockerPersonID: this.SelectedLockerPerson.LockerPersonID,
			MoveOutDate: moment(this.AssignedDate).format("MM/DD/YYYY"),
			AssignmentComment: this.AssignmentComment,
			LockerComment: this.LockerComment,
		};

		var result = this.StudentLockerService.LockerPersonUnassign(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "unassign",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Locker was unassigned successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "unassign",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not unassigned the Locker",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	////////////////////////////////////////
}
